import { articleListedState as state } from './articleListedState';
import * as els from './articleListedElements';

// Zobrazení tlačítek navigace
export const articleListedLoadButtons = (): void => {
  const CLASS_NAV_ITEM = 'article-listed-navigation__item';
  const CLASS_NAV_ITEM_VISIBLE = `${CLASS_NAV_ITEM}--visible`;

  // Reset viditelnosti tlačítek
  els.navigations.forEach((navigation) => {
    navigation.querySelectorAll('div').forEach((element) => {
      if (element.classList.contains(CLASS_NAV_ITEM_VISIBLE)) {
        element.classList.remove(CLASS_NAV_ITEM_VISIBLE);
      }
      const button = element.querySelector('button');
      if (button && button.hasAttribute('disabled')) {
        button.removeAttribute('disabled');
      }
    });
  });

  // Defaultni logika pro zobrazeni tlačítek
  switch (state.getIsLast()) {
    case true:
      // Poslední
      els.btnsPrev.forEach((btnPrev) => {
        (btnPrev as HTMLElement).classList.add(CLASS_NAV_ITEM_VISIBLE);
      });
      els.btnsLast.forEach((btnLast) => {
        (btnLast as HTMLElement).classList.add(CLASS_NAV_ITEM_VISIBLE);
      });

      break;
    default:
      switch (state.activeChapter) {
        case 1:
          // První
          els.btnsPrev.forEach((btnPrev) => {
            (btnPrev as HTMLElement).classList.add(CLASS_NAV_ITEM_VISIBLE);
            const button = btnPrev.querySelector('button');
            if (button) button.setAttribute('disabled', 'disabled');
          });
          els.btnsNext.forEach((btnNext) => {
            (btnNext as HTMLElement).classList.add(CLASS_NAV_ITEM_VISIBLE);
          });
          break;
        default:
          // Mezi
          els.btnsPrev.forEach((btnPrev) => {
            (btnPrev as HTMLElement).classList.add(CLASS_NAV_ITEM_VISIBLE);
          });
          els.btnsNext.forEach((btnNext) => {
            (btnNext as HTMLElement).classList.add(CLASS_NAV_ITEM_VISIBLE);
          });
      }
  }
};
